import { stringify } from 'query-string';
import authTokenUtil from '../../account/authTokenUtil';
import Logger from '../Logger';

function respond(response: Response) {
  return new Promise((resolve, reject) => {
    const handleUnknownError = (message: string) => {
      response.text().then((responseText: string) => {
        Logger.error(`${message} when requesting ${response.url}`, {
          response: responseText,
          source: 'utils/network/request.js',
        });
      });
      reject();
    };

    if (response.status >= 200 && response.status < 300) {
      response
        .json() // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((json: any) => {
          if (!json.errors) {
            resolve(json.data);
          } else {
            reject(json.errors);
          }
        })
        .catch(() => handleUnknownError('JSON parsing error'));

      return;
    }

    handleUnknownError('Unknown error');
  });
}

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function request(url: string, method: string, data?: any) {
  let fetchUrl = url;
  let fetchData = data;

  if (method === 'GET') {
    const queryString = stringify(data, {
      arrayFormat: 'bracket',
    });
    fetchUrl = queryString ? `${url}?${queryString}` : url;
    fetchData = null;
  }

  const authToken = authTokenUtil.get();
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const authHeader: any = authToken ? { Authorization: authToken } : {};
  return fetch(fetchUrl, {
    body: fetchData && JSON.stringify(fetchData),
    headers: {
      ...authHeader,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    method,
  }).then(respond);
}
